import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTwoDigitDecimaNumber]'
})
export class TwoDigitDecimaNumberDirective {

  // Allow decimal numbers and negative values
  //private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if(
      event.key=='.' ||
      event.key=='0' ||
      event.key=='1' ||
      event.key=='2' ||
      event.key=='3' ||
      event.key=='4' ||
      event.key=='5' ||
      event.key=='6' ||
      event.key=='7' ||
      event.key=='8' ||
      event.key=='9' ||
      event.key=='-' ||

      event.key=='ArrowRight' ||
      event.key=='ArrowLeft' ||

      event.key=='Backspace' ||

      event.key=='Tab'
    ){


      //only numbres and dot allowed
    }else{
      event.preventDefault();
    }

    let inputValue = this.el.nativeElement.value.toString();


    if(event.key=='.'){

      if(inputValue.match(/\./g) && inputValue.match(/\./g).length>=1){
        event.preventDefault();
      }
    }


    if (this.specialKeys.indexOf(event.key) !== -1) {return;}

    if(inputValue.indexOf(".")>=0 && this.countDecimals(this.el.nativeElement.value)>1){


      let selection = this.el.nativeElement.value.substring(this.el.nativeElement.selectionStart, this.el.nativeElement.selectionEnd);
      if(!selection){
        event.preventDefault();
      }


    }


    // // Allow Backspace, tab, end, and home keys
    // if (this.specialKeys.indexOf(event.key) !== -1) {
    //   return;
    // }
    // let current: string = this.el.nativeElement.value;
    // const position = this.el.nativeElement.selectionStart;
    // const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    // if (next && !String(next).match(this.regex)) {
    //   event.preventDefault();
    // }


    //this is working code for selection bug
    // let terere = this.el.nativeElement.value.substring(this.el.nativeElement.selectionStart, this.el.nativeElement.selectionEnd);
    // console.log("terere ",terere);

  }

  countDecimals(value){
    if(Math.floor(value) === value) return 0;
    return value.toString().split(".")[1].length || 0;
  }

}
